<template>
  <b-navbar v-if="!printMode" type="dark" class="layout-navbar align-items-lg-center container-p-x bg-secondary">
    <div class="app-brand demo app-brand-alt">
      <router-link to="/" class="app-brand-text demo sidenav-text font-weight-normal" tabindex="-1">
        <span class="logo">
          <img src="/img/logo_white.svg" alt="Floor Plan Mapper" />
        </span>
      </router-link>
    </div>

    <b-navbar-nav class="layout-sidenav-toggle d-lg-none align-items-lg-center mr-auto" v-if="sidenavEnabled">
      <a class="nav-item nav-link px-0 mr-lg-4" href="#" @click.prevent.stop="toggleSidenav">
        <i class="ion ion-md-menu text-large align-middle" />
      </a>
    </b-navbar-nav>

    <!-- Navbar toggle -->
    <!--    <b-navbar-toggle target="app-layout-navbar"></b-navbar-toggle>-->

    <b-collapse is-nav id="app-layout-navbar">
      <b-navbar-nav class="align-items-lg-center">
        <!-- Search -->
        <span class="nav-item navbar-text navbar-search-box p-0 active" v-if="isUserSigned">
          <i class="ion ion-ios-search navbar-icon align-middle search-icon"></i>
          <span class="navbar-search-input pl-2">
            <app-nav-search></app-nav-search>
          </span>
        </span>
      </b-navbar-nav>
    </b-collapse>

    <b-navbar-nav class="align-items-lg-center ml-auto">
      <span
        v-if="isUserSigned"
        class="d-inline-flex flex-lg-row-reverse align-items-center align-middle user-toggler"
        ref="user"
        @touchend.stop.prevent="userMenuEnabled = !userMenuEnabled"
        @click="userMenuEnabled = !userMenuEnabled"
        v-click-outside="() => (this.userMenuEnabled = false)"
      >
        <img src="/img/avatars/default.svg" alt class="d-block ui-w-30 rounded-circle" />
        <span class="px-1 mr-lg-2 ml-2 ml-lg-0 user-title">{{ userTitle }}</span>
      </span>
      <app-dropdown :dst-el="$refs.user" v-if="userMenuEnabled">
        <ul class="list-unstyled m-3">
          <li @click="logout" @touchend.stop.prevent="logout" class="cursor-pointer">
            <i class="ion ion-ios-log-out text-danger"></i> &nbsp;Log Out
          </li>
        </ul>
      </app-dropdown>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import AppNavSearch from './AppNavSearch'
import AppDropdown from '@/components/shared/AppDropdown'
import { SIDENAV_CLASSES } from '@/store'

export default {
  name: 'app-navbar',
  components: {
    AppDropdown,
    AppNavSearch
  },
  props: {
    sidenavEnabled: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    userMenuEnabled: false
  }),
  computed: {
    ...mapState(['sidenavClass']),
    ...mapState('map', ['printMode']),
    ...mapGetters('auth', ['userTitle', 'isUserSigned'])
  },
  methods: {
    ...mapActions('auth', { _logout: 'logout' }),
    ...mapActions(['setSidenavClass']),
    logout() {
      this._logout().then(() => this.$router.push({ name: 'login', query: { referer: location.href } }))
    },
    toggleSidenav() {
      if (this.sidenavClass === SIDENAV_CLASSES.expanded) {
        this.setSidenavClass('')
      } else {
        this.setSidenavClass(SIDENAV_CLASSES.expanded)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.user-toggler {
  color: #ebeef1;
  cursor: pointer;
  margin: 10px 0;
}

.user-title {
  @media (max-width: 500px) {
    display: none;
  }
}

.app-brand-alt {
  @media (max-width: 500px) {
    display: none;
  }
}

.search-icon {
  @media (max-width: 991px) {
    display: none;
  }
}
</style>
